import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { offerAssets } from "../data/offer";
type BundleDisplayProps = {
  dark?: boolean;
  glow?: boolean;
  className?: string;
};
export function BundleDisplay({
  dark = false,
  glow = true,
  className = ""
}: BundleDisplayProps) {
  const reducedMotion = useReducedMotion();
  return <div className={`relative mx-auto w-full max-w-[600px] ${className}`} data-id="element-1" data-mp="2sjgrmphme0km">
      {glow && <div className={`absolute left-1/2 top-[44%] h-2/3 w-2/3 -translate-x-1/2 rounded-full ${dark ? "bg-lime-400/15" : "bg-lime-300/35"} blur-3xl`} aria-hidden="true" data-id="element-2" data-mp="378wgu11i5xy7" />}
      <motion.img src={offerAssets.mainBundle} alt="Kit +100 Ensaladas para Bajar de Peso" className="relative z-10 mx-auto w-full drop-shadow-[0_24px_25px_rgba(26,51,31,0.2)]" animate={reducedMotion ? undefined : {
      y: [0, -5, -2, -6, 0],
      rotate: [0, 0.15, 0, -0.12, 0]
    }} transition={reducedMotion ? undefined : {
      duration: 4.4,
      repeat: Infinity,
      ease: [0.45, 0, 0.55, 1]
    }} data-id="element-3" data-mp="3gbfem6qflkdl" />
    </div>;
}